<template>
    <b-overlay :show="paymentLoading" :opacity="opacity" :blur="blur" :variant="paymentVariant" class="status-block" rounded="lg">
        <template #overlay>
            <div class="loading-overlay" :class="progressError ? 'error-progress' : ''">
                <p style="text-align: center; margin-bottom: 5px; font-size: 15px;" :style="progressWhite ? 'color: #ffffff !important' : ''">{{ loadingText }}</p>
                <b-progress :value="value" :max="max" show-progress></b-progress>
            </div>
        </template>
        <div class="position-relative">
            <p class="title-gray">Alege date de facturare:</p>
            <validation-observer #default="{ invalid }" ref="facturareSingle">
                <span class="display-none">{{ invalid }}</span>
                <div class="facturare-content">
                    <b-form-group>
                        <validation-provider
                            id="v-step-2"
                            #default="{ errors }"
                            rules="required"
                        >
                            <b-form-radio v-if="currentName" v-model="selected" :state="errors.length > 0 ? false : null" name="some-radios" value="A" @change="$emit('metodaFacturare', 'A')">Doresc ca serviciile sa îmi fie facturate
                                pentru:
                            </b-form-radio>
                            <p v-if="currentName" class="mb-4 company-name">{{ currentName }}</p>
                            <b-form-radio v-model="selected" :state="errors.length > 0 ? false : null" name="some-radios" value="B" @change="$emit('metodaFacturare', 'A')">Doresc ca serviciile sa îmi fie facturate pentru o altă companie:</b-form-radio>
                            <p class="mb-2"><strong>(proiectul poate fi scris pentru orice companie)</strong></p>
                        </validation-provider>
                    </b-form-group>
                </div>
                <div style="padding-bottom: 45px">

                    <b-form @submit.prevent="sendForm()">
                        <div v-if="selected === 'B'" class="flex align-end">
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group id="input-name" class="form-label">
                                    <label>Inserează CUI pentru facturare</label>
                                    <b-form-input
                                        id="name"
                                        v-model="cui"
                                        type="text"
                                        :state="errors.length > 0 ? false : null"
                                        placeholder="43743807"
                                        class="w-100"
                                    ></b-form-input>
                                </b-form-group>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                            <div class="search-button" @click="searchCompany()">Caută compania</div>
                        </div>
                        <p v-if="loading" class="mt-3">Interogăm compania...</p>
                        <p v-if="form.invoices[0].billing_name && selected !== 'A' && cui.length > 3" class="mt-3">
                            Factura va fi emisă pentru
                            <strong>{{ form.invoices[0].billing_name }}</strong>
                        </p>
                        <validation-provider
                            #default="{ errors }"
                            class="mt-3"
                            rules="required"
                        >
                            <b-form-group id="input-name" class="form-label">
                                <label>Reprezentant legal</label>
                                <b-form-input
                                    id="v-step-3"
                                    v-model="form.invoices[0].contact_person"
                                    :state="errors.length > 0 ? false : null"
                                    type="text"
                                    placeholder="Andrei Popescu"
                                    class="w-100"
                                    @input="$emit('legalRepresentant', form.invoices[0].contact_person)"
                                ></b-form-input>
                            </b-form-group>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>

                        <validation-provider
                            v-if="!phoneExists"
                            #default="{ errors }"
                            class="mt-3"
                            rules="required"
                        >
                            <b-form-group id="input-name" class="form-label">
                                <label>Număr de telefon</label>
                                <b-form-input
                                    id="name"
                                    v-model="form.customer_phone"
                                    :state="errors.length > 0 ? false : null"
                                    type="text"
                                    placeholder="0712345678"
                                    class="w-100"
                                ></b-form-input>
                            </b-form-group>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>

                        <div v-show="!(discounted === 0)" class="mt-3">
                            <span class="span-title flex justify-content-start yellow-text border-bottom-white">Modalitatea de plată</span>
                            <b-form-radio-group
                                id="v-step-4"
                                v-model="form.payment_method"
                                :options="payment_methods"
                                :reduce="(option => option.id)"
                                text="label"
                                class="modalitate-plata mt-3"
                                :clearable="false"
                            >
                            </b-form-radio-group>
                        </div>
                        <div v-if="!(discounted === 0)">
                            <div v-if="shouldShowPaymentInstructions" class="mt-3 payment-instructions">
                                <span class="span-title flex justify-content-start yellow-text border-bottom-white">Instructiuni</span>
                                <p class="pt-3" v-html="paymentInstructions"></p>
                            </div>
                            <div v-else class="mt-3 payment-instructions flex items-center">
                                <img alt="Netopia" src="@/assets/images/netopia/logo.svg" class="netopia-logo">
                                <img alt="Netopia" src="@/assets/images/netopia/cardLogos.png" class="netopia-logo ml-5">

                            </div>
                        </div>
                        <validation-provider
                            #default="{ errors }"
                            class="mt-3"
                            :rules="{ required: { allowFalse: false } }"
                        >
                            <b-form-checkbox
                                id="v-step-5"
                                v-model="status"
                                name="checkbox-1"
                                style="margin-top:30px;"
                                :state="errors.length > 0 ? false : null"
                                @change="$emit('termsAccepted', status)"
                            >
                                Sunt de acord cu <a href="https://smis.ro/termeni-si-conditii/" target="_blank">termenii și condițiile</a>, <a href="https://smis.ro/politica-de-confidentialitate/" target="_blank">politica de confidentialitate</a>, <a href="https://smis.ro/cookies-gdpr" target="_blank">politica de cookies</a>, <a href="https://smis.ro/politica-livrare-servicii" target="_blank">politica de livrare</a> și <a href="https://smis.ro/politica-retur" target="_blank">politica de retur</a>.
                            </b-form-checkbox>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                        <b-button
                            id="v-step-6"
                            type="submit"
                            class="green-button"
                        >Transmite comanda</b-button>
                    </b-form>
                </div>
            </validation-observer>
        </div>
        <CheckoutMissingInputsModal :show-modal="showMissingInputsModal" :inputs="missingInputs" @savedForm="saveChanges($event)" @hideTempModal="showMissingInputsModal = false"></CheckoutMissingInputsModal>
    </b-overlay>
</template>

<script>
    import {BForm, BFormGroup, BFormInput, BButton, BIconCheckCircleFill, BFormRadioGroup, BFormRadio, BFormCheckbox, BOverlay, BProgress} from 'bootstrap-vue';
    import {ValidationProvider, ValidationObserver} from 'vee-validate'
    import axios from '@/helpers/axios'
    import api from '@/helpers/api'
    import CheckoutMissingInputsModal from "./CheckoutMissingInputsModal";
    import smartlookClient from 'smartlook-client'

    require('@/helpers/validations/validations')
    export default {
        name: 'FacturareSingle',
        components: {
            BForm,
            BFormGroup,
            BFormInput,
            BButton,
            BIconCheckCircleFill,
            BFormRadioGroup,
            BFormRadio,
            BFormCheckbox,
            BOverlay,
            BProgress,
            ValidationProvider,
            ValidationObserver,
            CheckoutMissingInputsModal
        },
        props: {
            planId: null,
            discounted: null,
        },
        data() {
            return {
                /* LOADING */
                paymentLoading: false,
                paymentVariant: 'light',
                opacity: 0.95,
                blur: '20px',
                progressError: false,
                progressWhite: false,
                value: 0,
                max: 100,
                loadingText: 'Plata este în curs de procesare.',

                currentName: '',
                tipFacturare: '',
                selected: '',
                cui: '',
                form: {
                    plan_id: null,
                    plan_type: 'lifetime',
                    licenses: 1,
                    payment_method: '',
                    coupons: [],
                    customer_sold: 0,
                    customer_phone: '',
                    invoices: [
                        {
                            billing_name: '',
                            billing_address: '',
                            billing_state: '',
                            billing_city: '',
                            business_id: '',
                            reg_no: '',
                            bank_name: null,
                            bank_account: null,
                            contact_person: null,
                            contact_person_job: null,
                            discount: 0,
                        }
                    ]
                },
                creatingPayment: false,
                payment_methods: [],
                defaultCompany: {},
                loading: false,
                status: false,
                showMissingInputsModal: false,
                missingInputs: [],
                phoneExists: null,
            }
        },

        computed: {
            firstPaymentMethod() {
                return this.payment_methods.length > 0 ? this.payment_methods[0].id : '';
            },

            shouldShowPaymentInstructions() {
                return this.form.payment_method == 'bank_transfer';
            },

            paymentInstructions() {
                if (this.shouldShowPaymentInstructions) {
                    return this.payment_methods.find(gateway => gateway.id == this.form.payment_method).instructions;
                }

                return '';
            },

            calculateDiscount() {
                let sum = 0;
                if(! this.form.coupons || this.form.coupons.length == 0) {
                    return sum;
                }
                this.form.coupons.forEach(coupon => {
                    sum += coupon.discount;
                })
                return sum;
            },
        },

        watch: {
            'selected': {
                handler: function(value) {
                    if(value === 'A') {
                        this.form.invoices[0] = this.defaultCompany
                        this.cui = ''
                    }
                },
                immediate: true
            },
            'planId': {
                handler: function(value) {
                    this.form.plan_id = value
                },
                immediate: true
            }
        },

        mounted() {
            if(JSON.parse(localStorage.getItem('user')) && JSON.parse(localStorage.getItem('user')).phone)
                this.phoneExists = true;
            if(JSON.parse(localStorage.getItem('currentM3Company')) && JSON.parse(localStorage.getItem('currentM3Company')).name){
                this.currentName = JSON.parse(localStorage.getItem('currentM3Company')).name
                this.getDefaultCompany()
            } else {
                axios.get(api.API_ENDPOINTS.m3company)
                    .then(response => {
                        if (response.data && response.data.length === 0) {
                            this.errorMessage = 'Nu există companii adăugate pe acest cont.'
                            this.selected = 'B'
                        } else {
                            let company = response.data[0];
                            if (!JSON.parse(localStorage.getItem('currentM3Company')) || !JSON.parse(localStorage.getItem('currentM3Company')).id) {
                                localStorage.setItem('currentM3Company', JSON.stringify(company))
                                this.currentName = JSON.parse(localStorage.getItem('currentM3Company')).name
                                this.getDefaultCompany()
                            }
                        }
                    })
            }
            this.getCheckout()

        },

        methods: {
            getCheckout() {
                this.$emit('loadingStatus', true)
                axios.get(api.API_ENDPOINTS.checkout + '/' + this.form.plan_id + '/' + this.form.plan_type)
                    .then((response) => {
                        this.payment_methods = response.data.gateways.filter(gateway => { return gateway.value != 'smispay' });
                        this.form.coupons = response.data.coupons;
                        this.$emit('coupons', this.calculateDiscount)

                        if (this.firstPaymentMethod) {
                            this.form.payment_method = this.firstPaymentMethod;
                        }
                        this.$emit('loadingStatus', false)
                    })
            },

            getDefaultCompany() {
                axios.get(api.API_ENDPOINTS.m3 + JSON.parse(localStorage.getItem('currentM3Company')).business_id)
                    .then(response => {
                        this.defaultCompany = this.form.invoices[0] = {
                            billing_name: response.data.DateGenerale.nume,
                            billing_address: response.data.DateGenerale.adresa,
                            billing_state: response.data.DateGenerale.judet,
                            billing_city: response.data.DateGenerale.judet === 'BUCURESTI' ? 'BUCURESTI, SECTORUL ' + response.data.DateGenerale.localitate : response.data.DateGenerale.localitate,
                            business_id: response.data.DateGenerale.cui,
                            reg_no: response.data.DateGenerale.cod_inmatriculare,
                            bank_name: null,
                            bank_account: null,
                            contact_person: null,
                            contact_person_job: null,
                            discount: 0,
                        };
                    })
            },

            progressFailed(message) {
                this.progressError = true
                this.loadingText = 'A apărut o eroare la procesarea plății.'
                this.paymentVariant = 'danger'
                setTimeout(() => {
                    this.paymentLoading = false
                    this.paymentVariant = 'light'
                    this.loadingText = 'Plata este în curs de procesare.'
                    this.progressWhite = false
                    this.progressError = false
                    this.value = 0
                    this.$toast.error(message);
                }, 1100)
            },

            progressSuccess(message) {
                this.value = 100
                this.paymentVariant = 'success'
                this.loadingText = 'Plata a fost procesată cu succes.'
                this.progressWhite = true
                setTimeout(() => {
                    this.paymentLoading = false
                    this.paymentVariant = 'light'
                    this.loadingText = 'Plata este în curs de procesare.'
                    this.progressWhite = false
                    this.value = 0
                    this.$emit('thankYouPage', this.paymentMethod)
                    this.$toast.success(message);
                }, 1100)
            },

            searchCompany() {
                this.loading = true
                axios.get(api.API_ENDPOINTS.m3 + this.cui)
                    .then(response => {
                        this.form.invoices[0] = {
                            billing_name: response.data.DateGenerale.nume,
                            billing_address: response.data.DateGenerale.adresa,
                            billing_state: response.data.DateGenerale.judet,
                            billing_city: response.data.DateGenerale.judet === 'BUCURESTI' ? 'BUCURESTI, SECTORUL ' + response.data.DateGenerale.localitate : response.data.DateGenerale.localitate,
                            business_id: response.data.DateGenerale.cui,
                            reg_no: response.data.DateGenerale.cod_inmatriculare,
                            bank_name: null,
                            bank_account: null,
                            contact_person: null,
                            contact_person_job: null,
                            discount: 0,
                        };
                        if(this.form.invoices[0].billing_name === this.currentName){
                            this.selected = 'A'
                        }
                        this.checkPaymentInfo();
                    })
                    .finally(() => this.loading = false)
            },
            saveChanges(event){

                let results = 0;

                if(event[0]['address'])
                {
                    this.form.invoices[0].billing_address = event[0]['address'];
                    results++;
                }
                if(event[0]['name'])
                {
                    this.form.invoices[0].billing_name = event[0]['name'];
                    results++;
                }
                if(event[0]['state'])
                {
                    this.form.invoices[0].billing_state = event[0]['state'];
                    results++;
                }
                if(event[0]['city'])
                {
                    this.form.invoices[0].billing_city = event[0]['city'];
                    results++;
                }
                if(event[0]['reg_no'])
                {
                    this.form.invoices[0].reg_no = event[0]['reg_no'];
                    results++;
                }

                if(results === this.missingInputs.length)
                    this.missingInputs = [];

            },
            checkPaymentInfo(){
                if(!this.form.invoices[0].billing_address)
                    if(!this.missingInputs.includes('address'))
                        this.missingInputs.push('address')
                if(!this.form.invoices[0].billing_name)
                    if(!this.missingInputs.includes('name'))
                        this.missingInputs.push('name')
                if(!this.form.invoices[0].billing_city)
                    if(!this.missingInputs.includes('city'))
                        this.missingInputs.push('city')
                if(!this.form.invoices[0].billing_state)
                    if(!this.missingInputs.includes('state'))
                        this.missingInputs.push('state')
                if(!this.form.invoices[0].reg_no)
                    if(!this.missingInputs.includes('reg_no'))
                        this.missingInputs.push('reg_no')

                if(this.missingInputs.length){
                    this.showMissingInputsModal = true;
                    return false;
                }
                return true;
            },
            sendForm() {
                this.$refs.facturareSingle.validate().then((e) => {
                    if (!e) {
                        this.completed = false
                        this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                        return;
                    }

                    this.paymentLoading = true
                    this.value = 30
                    this.postCheckout()
                })
            },

            postCheckout() {
                if (this.creatingPayment) {
                    return;
                }

                if(!this.checkPaymentInfo()){
                    this.paymentLoading = false
                    return;
                }

                this.creatingPayment = true;
                let form = this.form;
                form.return = this.$route.path.replace('/', '');
                if(this.discounted === 0)
                    this.form.payment_method = 'smispay';

                return axios.post(api.API_ENDPOINTS.payments, form)
                    .then((response) => {
                        if (response.data.url) {
                            this.redirect = response.data;
                            this.$emit('redirect', response.data)
                            this.$emit('thankYouPage', form.payment_method)
                            axios.get(api.API_ENDPOINTS.m3Licenses)
                                .then(responseLicenses => {
                                    this.$store.dispatch('m3Sketch/setLicenses', responseLicenses.data)
                                })
                        } else {
                            this.value = 70
                            this.confirmPayment(response.data.paymentId, form.payment_method);
                        }
                    }).catch((xhr) => {
                        this.progressFailed()
                        if (xhr && xhr.response && xhr.response.status === 422 && xhr.response.data && xhr.response.data.errors) {
                            Object.values(xhr.response.data.errors).forEach(error => {
                                this.$toast.error(error[0]);
                            });
                        }

                        this.creatingPayment = false;
                    });
            },

            confirmPayment(paymentId, paymentMethod) {
                return axios.get(api.API_ENDPOINTS.payments + '/' + paymentId + '/complete/' + paymentMethod)
                    .then((response) => {
                        this.progressSuccess(response.data.message)
                        smartlookClient.track('transaction', {
                            value: this.discounted,
                            currency: 'ron',
                            product: 'Licență M3Sketch',
                        })
                        axios.get(api.API_ENDPOINTS.m3Licenses)
                            .then(responseLicenses => {
                                this.$store.dispatch('m3Sketch/setLicenses', responseLicenses.data)
                            })

                    }).catch((xhr) => {
                        this.creatingPayment = false;
                        this.deletePayment(paymentId);
                        this.progressFailed(xhr.response.data.message)
                    });
            },

            deletePayment(paymentId) {
                if (! paymentId) {
                    return;
                }

                return axios.get(api.API_ENDPOINTS.payments + '/' + paymentId + '/payment-canceled');
            },
        }
    }
</script>

<style scoped>
/* LOADING */
.loading-overlay{
    width: 100%;
}
.loading-overlay >>> .progress{
    min-width: 350px;
}
.loading-overlay >>> .progress-bar{
    background-color: inherit;
    background: linear-gradient(to right,#69586e, #22686c);
}
.error-progress >>> .progress-bar{
    background: #ff7070 !important;
}
.error-progress >>> p{
    color: #fff !important;
}


.text-danger {
    position: absolute;
}

.flex {
    display: flex;
}

.align-end {
    align-items: flex-end;
}
.items-center{
    align-items: center;
}
.search-button {
    background: #49cda8;
    width: 100%;
    max-width: 120px;
    color: #fff;
    font-size: 12px;
    padding: 3px 5px;
    cursor: pointer;
    transition: 0.3s;
    border-radius: 4px;
    text-align: center;
    min-height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 6px;
}

.search-button:hover {
    background: #3db694;
}

.title-gray {
    color: #969db6;
    font-size: 17px;
    margin-bottom: 25px;
}

p {
    font-size: 13px;
    color: #969db6;
}

.text-danger {
    font-size: 12px;
}

.company-name {
    font-weight: 800;
    font-size: 15px;
    text-transform: uppercase;
}

.form-group {
    margin-bottom: 0;
    margin-top: 10px;
}

.form-group >>> label {
    font-size: 13px;
    color: #969db6;
    font-weight: 600;
    margin: 0;
}

.form-group >>> input {
    font-size: 13px;
    color: #969db6;
    font-weight: 600;
    max-width: 330px;
    max-height: 30px;
}

.form-group >>> input::placeholder {
    opacity: 0.3;
}

.pointer-none {
    pointer-events: none;
    opacity: 0.4;
}

.green-button {
    background: linear-gradient(to bottom, #02c694, #02a5ae);
    padding: 5px;
    text-align: center;
    margin: 97px auto 0 auto;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 240px;
    font-size: 15px;
    font-weight: 700;
    transition: 0.4s;
    color: #fff;
    cursor: pointer;
    display: flex;
	border: none;
}
.disabled-button{
    background: linear-gradient(to bottom, #5a5a5a, #686868);
    padding: 5px;
    opacity: 0.7;
    text-align: center;
    margin: 97px auto 0 auto;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 240px;
    font-size: 15px;
    font-weight: 700;
    transition: 0.4s;
    color: #fff;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    /*pointer-events: none;*/
}

.position-relative {
    position: relative;
    height: 100%;
    min-height: 477px;
}
.netopia-logo{
    max-height: 45px;
}
</style>
